import { cn } from "@/lib/utils";

interface S1LogoProps {
  size?: number;
  height?: number;
  variant?: "icon" | "full";
  className?: string;
}

export function S1Logo({ size = 32, height = 40, variant = "icon", className }: S1LogoProps) {
  if (variant === "full") {
    return (
      <img
        src="/logo.png"
        alt="Système1-Immo"
        style={{ height }}
        className={cn("w-auto select-none", className)}
        draggable={false}
      />
    );
  }

  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-xl bg-foreground select-none",
        className
      )}
      style={{ width: size, height: size }}
      aria-label="Systeme1-immo"
    >
      <span
        className="text-card font-bold leading-none tracking-tight"
        style={{ fontSize: size * 0.44 }}
      >
        S1
      </span>
    </div>
  );
}
